var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTypePdf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_41979_9060)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.99999 0.0322266H10.4965L15 4.51824V15.0322C15 15.5847 14.552 16.0322 14 16.0322H1.99999C1.44798 16.0322 1 15.5847 1 15.0322V1.03222C1 0.479736 1.44803 0.0322266 1.99999 0.0322266Z",
    fill: "#E2574C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9855 4.53223H11.5C10.948 4.53223 10.5 4.08426 10.5 3.53224V0.0422363L14.9855 4.53223Z",
    fill: "#B53629"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2489 7.61383C11.4164 7.61383 11.4984 7.46784 11.4984 7.32634C11.4984 7.17983 11.4129 7.03833 11.2489 7.03833H10.2949C10.1084 7.03833 10.0044 7.19281 10.0044 7.36333V9.70782C10.0044 9.91683 10.1234 10.0328 10.2844 10.0328C10.4444 10.0328 10.5639 9.91683 10.5639 9.70782V9.06433H11.1409C11.3199 9.06433 11.4094 8.91782 11.4094 8.77234C11.4094 8.62986 11.3199 8.48831 11.1409 8.48831H10.5639V7.61383H11.2489ZM8.02438 7.03833H7.32637C7.13686 7.03833 7.00235 7.16834 7.00235 7.36131V9.70983C7.00235 9.94932 7.19584 10.0243 7.33433 10.0243H8.06685C8.93383 10.0243 9.50633 9.45385 9.50633 8.57331C9.50587 7.64234 8.96689 7.03833 8.02438 7.03833ZM8.0579 9.44536H7.63238V7.61735H8.01589C8.59642 7.61735 8.84888 8.00687 8.84888 8.54434C8.84888 9.04736 8.60086 9.44536 8.0579 9.44536ZM5.50089 7.03833H4.8094C4.61389 7.03833 4.50488 7.16731 4.50488 7.36333V9.70782C4.50488 9.91683 4.62987 10.0328 4.79786 10.0328C4.96584 10.0328 5.09084 9.91683 5.09084 9.70782V9.02331H5.52433C6.05932 9.02331 6.50083 8.6443 6.50083 8.0348C6.50088 7.43835 6.07489 7.03833 5.50089 7.03833ZM5.4894 8.47336H5.09089V7.58885H5.4894C5.73541 7.58885 5.8919 7.78083 5.8919 8.03134C5.89139 8.28137 5.73541 8.47336 5.4894 8.47336Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_41979_9060"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.0322266)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTypePdf);
export default __webpack_public_path__ + "static/media/typePdf.6ac36a49.svg";
export { ForwardRef as ReactComponent };